import { can, useMe } from '../../auth/AuthContext';
import { PageHeader } from '../../components/ui';
import { WhatsAppWorkspace } from '../../components/whatsapp/WhatsAppWorkspace';

/** Tenant portal: the organisation's WhatsApp Business number and everything that runs on it. */
export function WhatsApp() {
  const me = useMe();
  return (
    <>
      <PageHeader eyebrow="Portal" title="WhatsApp" />
      <WhatsAppWorkspace
        canManage={can(me, 'tenant:whatsapp:manage')}
        canConnect={can(me, 'tenant:whatsapp:connect')}
      />
    </>
  );
}
